import 'whatwg-fetch';
import cookies from './cookies';
import { bootstrap, BootstrapperConfig } from '@central-products/welcome-messages-bootstrapper';
import MessageBusTransport from '@central-products/message-transport-bus';
import { DataAccessServiceInterface } from '@central-products/interface-data-access-service';
import { AccountActionsInterface } from '@central-products/interface-account-actions';
import { SessionServiceInterface } from '@central-products/interface-session-service';
import { WelcomeMessagesFlowInterface } from '@central-products/welcome-messages-flow-interface';
import { WelcomeMessagesProviderInterface } from '@central-products/interface-welcome-messages-campaign-provider';
import { getLocale, getJurisdiction, getEnv, getMarketingPreferencePageUrl, getProjectName } from './utils';

declare global {
  interface Window {
    WH: {
      // tslint:disable-next-line:no-any
      messageBus: any;
      bootstrapper: {
        features: {
          'data-access-service': DataAccessServiceInterface;
          'account-actions': AccountActionsInterface;
          'session-service': SessionServiceInterface;
          'welcome-messages-flow': WelcomeMessagesFlowInterface;
          'welcome-messages-campaign-provider': WelcomeMessagesProviderInterface;
        };
      };
      sportsbook?: {
        frontEndConfig: {
          overlayIntegrationEnabled: boolean;
        };
        lang?: string;
      };
    };
    consoleReference?: typeof console;
    docCookies?: {
      getItem(key: string): string | undefined;
    };
  }
}

const WM_IMAGE_CONVERTER_REQ_TIMEOUT = 3000;

async function app() {
  const jurisdiction = getJurisdiction();
  const environment = getEnv();
  const optInTimeout = 4000;
  const config: BootstrapperConfig = {
    langCode: getLocale(),
    jurisdiction,
    environment,
    optInTimeout,
    marketingPreferencePageUrl: getMarketingPreferencePageUrl(jurisdiction, environment),
    project: getProjectName(),
    imageConversionReqTimeout: WM_IMAGE_CONVERTER_REQ_TIMEOUT,
    disableLoginTrigger: false,
  };

  try {
    const init = bootstrap(config, MessageBusTransport.getInstance());

    init();
  } catch (err) {
    window.console.error(err);

    throw new Error('Failed to bootstrap Welcome Messages dependencies');
  }

  const shouldLoadCookieBanner = !(
    window.WH.sportsbook && window.WH.sportsbook.frontEndConfig.overlayIntegrationEnabled
  );

  if (shouldLoadCookieBanner) {
    cookies(window.WH.messageBus, config.langCode);
  }
}

app();
